var app = angular.module('CDI', ['ui.router', 'ui.bootstrap.pagination', 'ngMaterial', 'ngAnimate',
    'ngAria', 'ngMessages', 'ui-notification', 'ngFileUpload', 'vAccordion', 'xeditable', 'uiGmapgoogle-maps',
    'nemLogging'
]);

app.run(function(editableOptions) {
    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
    editableOptions.icon_set = 'font-awesome';
});

app.config(function($httpProvider, $locationProvider, $stateProvider, _$filterProvider, _$breadcrumbsProvider, _$paginatorProvider,uiGmapGoogleMapApiProvider) {
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

    uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyBorFJjii6Jlf0twt2NBnqCn1K--8ptQ4c',
        // v: '3.28',
        libraries: 'visualization'
    });

    //loader
    $httpProvider.interceptors.push(function($document, $q, $window, $rootScope) {
        return {
            'request': function(config) {
                // same as above

                $document.find("body").addClass("mouse-loader");
                $document.find("md-progress-linear").addClass("show");

                return config;
            },
            'response': function(response) {
                // same as above

                $document.find("body").removeClass("mouse-loader");
                $document.find("md-progress-linear").removeClass("show");

                return response;
            },
            responseError: function(response) {
                // same as above
                $document.find("body").removeClass("mouse-loader");
                $document.find("md-progress-linear").removeClass("show");

                if (response.status == 401) {
                    $window.location.href = "/";
                } else if (response.status == 403 || response.status == 405) {
                    $rootScope.notification.showAfterRedirect('base', {}, 'error', 'Nie posiadasz uprawnień do wykonania określonej akcji');
                } else {
                    //use global object
                    toast.error("W systemie wystąpił błąd. Przepraszamy.");
                }

                return $q.reject(response);
            }
        };
    });


    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    var path = '/assets/js/angular';
    _$breadcrumbsProvider.setBreadcrumbs({
        "message": {
            label: "Centrum wiadomości"
        },
        "reports": {
            label: "Zgłoszenia",
            state: "message.reports"
        },
        "notificationscategories": {
            label: "Kategorie wiadomości",
            state: "admin_notificationscategories"
        },
        "events": {
            label: "Dzienniki",
            state: "admin_events"
        },
        "unit": {
            label: "Struktura organizacyjna",
            state: "admin_unit"
        },
        "subunit": {
            label: "Jednostki podległe",
            state: "admin_subunit"
        },
        "backup": {
            label: "Kopia zapasowa",
            state: "admin_backup"
        },
        "systemsettings": {
            label: "Ustawienia",
            state: "admin_systemsettings"
        },
        "recipients": {
            label: "Odbiorcy",
            state: "recipients"
        },
        "recipient": {
            label: "Odbiorcy",
            state: "recipients"
        },
        "fastauth": {
            label: "Szybka autoryzacja",
            state: "recipients_fastauth"
        },
        "rcnew": {
            label: "Nowy odbiorca",
            state: "recipients_rcnew"
        },
        "rcedit": {
            label: "Edycja odbiorcy",
            state: "recipients_rcedit"
        },
        "rcgroup": {
            label: "Grupy odbiorców",
            state: "message_rcgroup"
        },
        "rcnewgroup": {
            label: "Nowa grupa",
            state: "message_rcnewgroup"
        },
        "rceditgroup": {
            label: "Edycja grupy",
            state: "message_rceditgroup"
        },
        "msgnew": {
            label: "Nowa wiadomość",
            state: "message_msgnew"
        },
        "msgnewids": {
            label: "Nowa wiadomość",
            state: "message_msgnewids"
        },
        "msgedit": {
            label: "Edycja wiadomości",
            state: "message_msgedit"
        },
        "msgdetails": {
            label: "Szczegóły wiadomości",
            state: "message_msgdetails"
        },
        "drafts": {
            label: "Wiadomości robocze",
            state: "message_drafts"
        },
        "waiting": {
            label: "Skrzynka nadawcza",
            state: "message_waitings"
        },
        "send": {
            label: "Wiadomości wysłane",
            state: "message_send"
        },
        "templates": {
            label: "Szablony wiadomości",
            state: "message_templates"
        },
        "templatenew": {
            label: "Nowy szablon",
            state: "message_templates_templatenew"
        },
        "templateedit": {
            label: "Edycja szablonu",
            state: "message_templates_templateedit"
        },
        "templatedetails": {
            label: "Szczegóły szablonu",
            state: "message_templates_templatedetails"
        },
        "users": {
            label: "Użytkownicy systemu",
            state: "admin_users"
        },
        "admin": {
            label: "Administracja"
        },
        "recivers": {
            label: "Grupy odbiorców",
            state: "admin_recivers"
        },
        "settings": {
            label: "Ustawienia konta",
            state: "settings"
        },
        "changepassword": {
            label: "Zmiana hasła",
            state: "changepassword"
        },
        "systemcontent": {
            label: "Treści",
            state: "admin_systemcontent"
        },
        "systemapi": {
            label: "Systemy API",
            state: "admin_systemapi"
        },
        "team": {
            label: "Typy konta odbiorców",
            state: "admin_team"
        },
        "team_add": {
            label: "Nowy typ konta",
            state: "admin_team_new"
        },
        "team_edit": {
            label: "Edycja typu konta",
            state: "admin_team_edit"
        },
        "reportmaps": {
            label: "Mapa zgłoszeń",
            state: "message_reportmaps"
        }
    });


    //set how many elements on paginator
    _$paginatorProvider.setPerPage(20);

    _$filterProvider.setPath(path + "/components/directives/filters");

    viewVersion = 61;

    $stateProvider
        .state('base', {
            url: '/app',
            controller: 'Dashboard',
            templateUrl: path + '/dashboard/view.html?v=' + viewVersion

        })
        .state('settings', {
            url: '/app/usersettings',
            controller: 'UserSettings',
            templateUrl: path + '/settings/views/view.html?v=' + viewVersion

        })
        // .state('settings_changepassword', {
        //     url: '/app/usersettings/changepassword/:userid/:token',
        //     controller: 'PasswordSettings',
        //     templateUrl: path + '/settings/views/newpassword.html'
        // })
        /*
         * ODBIORCY
         */
        .state('recipients', {
            url: '/app/recipients',
            templateUrl: path + '/recipients/views/recipients.html?v=' + viewVersion,
            controller: 'Recipients',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("receiver");

                }
            }
        })
        .state('recipients_rcnew', {
            url: '/app/recipients/new',
            templateUrl: path + '/recipients/views/recipient_new.html?v=' + viewVersion,
            controller: 'RecipientNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("receiver");

                }
            }
        })
        .state('recipient', {
            url: '/app/recipients/view/:id',
            templateUrl: path + '/recipients/views/recipient.html?v=' + viewVersion,
            controller: 'Recipient',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("receiver");

                }
            }
        })
        .state('recipients_rcedit', {
            url: '/app/recipients/edit/:id',
            templateUrl: path + '/recipients/views/recipient_new.html?v=' + viewVersion,
            controller: 'RecipientEdit',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("receiver");

                }
            }
        })
        .state('recipients_fastauth', {
            url: '/app/recipients/fastauth',
            templateUrl: path + '/recipients/views/recipients_fast_auth.html?v=' + viewVersion,
            controller: 'RecipientFastAuth',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("receiver");

                }
            }
        })
        /*
         * ODBIORCY - GRUPY
         */
        .state('message_rcgroup', {
            url: '/app/message/group',
            templateUrl: path + '/recipients/views/recipients_group.html?v=' + viewVersion,
            controller: 'RecipientsGroup',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_rcgroup_rcnewgroup', {
            url: '/app/message/group/new',
            templateUrl: path + '/recipients/views/recipients_new_group.html?v=' + viewVersion,
            controller: 'RecipientsNewGroup',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_rcgroup_rcdetailsgroup', {
            url: '/app/message/group/view/:id',
            templateUrl: path + '/recipients/views/recipients_new_group.html?v=' + viewVersion,
            controller: 'RecipientsDetailsGroup',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_rcgroup_rceditgroup', {
            url: '/app/message/group/edit/:id',
            templateUrl: path + '/recipients/views/recipients_new_group.html?v=' + viewVersion,
            controller: 'RecipientsNewGroup',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        /*
         * WIADOMOŚCI
         */
        .state('message', {
            url: '/app/message',
            abstract: true,
            template: '<ui-view/>',
        })

    .state('message_msgnew', {
            url: '/app/message/new',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_msgnewids', {
            url: '/app/message/new/:ids',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_msgdetails', {
            url: '/app/message/details/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        /*
         * WIADOMOŚCI WYSŁANE
         */
        .state('message_send', {
            url: '/app/message/send',
            templateUrl: path + '/message/views/send.html?v=' + viewVersion,
            controller: 'MessageSend',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_send_msgedit', {
            url: '/app/message/send/edit/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_send_msgdetails', {
            url: '/app/message/send/details/:id/:signed',
            params: {
                signed: {
                    squash: true,
                    value: null
                }
            },
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })

    /*
     * WIADOMOŚCI NADAWCZA
     */
    .state('message_waiting', {
            url: '/app/message/waiting',
            templateUrl: path + '/message/views/waiting.html?v=' + viewVersion,
            controller: 'MessageWaiting',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_waiting_msgedit', {
            url: '/app/message/waiting/edit/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_waiting_msgdetails', {
            url: '/app/message/waiting/details/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        /*
         * WIADOMOŚCI ROBOCZE
         */
        .state('message_drafts', {
            url: '/app/message/drafts',
            templateUrl: path + '/message/views/drafts.html?v=' + viewVersion,
            controller: 'MessageDrafts',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_drafts_msgedit', {
            url: '/app/message/drafts/edit/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_drafts_msgdetails', {
            url: '/app/message/drafts/details/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        /*
         * SZABLONY
         */
        .state('message_templates', {
            url: '/app/message/templates',
            templateUrl: path + '/message/views/templates.html?v=' + viewVersion,
            controller: 'MessageTemplates',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_templates_templatenew', {
            url: '/app/message/templates/new',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageTemplateNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_templates_templateedit', {
            url: '/app/message/templates/edit/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageTemplateNew',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        .state('message_templates_templatedetails', {
            url: '/app/message/templates/details/:id',
            templateUrl: path + '/message/views/new.html?v=' + viewVersion,
            controller: 'MessageTemplateDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("message");

                }
            }
        })
        /*
         * ZGŁOSZENIA
         */
        .state('message.reports', {
            url: '/reports',
            templateUrl: path + '/message/views/reports.html?v=' + viewVersion,
            controller: 'MessageReports',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("report");

                },
                states: function($http, _$report) {

                    return _$report.getStates();
                },
                types: function($http, _$report) {

                    return _$report.getTypes();
                },
                categories: function($http, _$report){
                    return _$report.getCategories();
                }
            }

        })
        .state('message.reports_rdetails', {
            url: '/reports/details/{id}',
            templateUrl: path + '/message/views/report_detail.html?v=' + viewVersion,
            controller: 'MessageReportDetails',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("report");

                },
                report: function(_$report, $stateParams) {

                    return _$report.getSingle($stateParams.id);
                },
                states: function(_$report) {

                    return _$report.getStates();
                },
                types: function(_$report) {

                    return _$report.getTypes();
                },
                ends: function(_$report) {

                    return _$report.getEnds();
                },
                connected: function(_$report, $stateParams) {

                    return _$report.getConnectedReports($stateParams.id);
                },
                toConnectReports: function(_$report, $stateParams) {

                    return _$report.getPossibleToConnectReports($stateParams.id);
                }

            }
        })
        .state('message_reportmaps', {
            url: '/app/message/reports/map',
            templateUrl: path + '/message/views/report_map.html?v=' + viewVersion,
            controller: 'MessageReportsMap',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("report");
                }
            }
        })

        /*
         * ADMINISTRACJA
         */
        .state('admin_unit', {
            url: '/app/administration/unit',
            templateUrl: path + '/administration/views/units.html',
            controller: 'Units',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_subunit', {
            url: '/app/administration/unit/:type',
            templateUrl: path + '/administration/views/units.html?v=' + viewVersion,
            controller: 'Units',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_unit_new', {
            url: '/app/administration/unit/:type/:action',
            templateUrl: path + '/administration/views/unit_edit.html?v=' + viewVersion,
            controller: 'Units',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_unit_edit', {
            url: '/app/administration/unit/:type/:action/:id',
            templateUrl: path + '/administration/views/unit_edit.html?v=' + viewVersion,
            controller: 'Units',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        /*
         * UŻYTKOWNICY
         */
        .state('admin_users', {
            url: '/app/administration/users',
            controller: 'AdministrationUsers',
            templateUrl: path + '/administration/views/users.html?v=' + viewVersion,
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_users_new', {
            url: '/app/administration/users/:action',
            templateUrl: path + '/administration/views/user_edit.html?v=' + viewVersion,
            controller: 'AdministrationUserEdit',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_users_edit', {
            url: '/app/administration/users/:action/:id',
            templateUrl: path + '/administration/views/user_edit.html?v=' + viewVersion,
            controller: 'AdministrationUserEdit',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })

    /*
     * GRUPY ODBIORCÓW
     */
    .state('admin_recivers', {
            url: '/app/administration/recivers',
            templateUrl: path + '/administration/views/recivers.html?v=' + viewVersion,
            controller: 'Recivers',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_recivers_new', {
            url: '/app/administration/recivers/:action',
            templateUrl: path + '/administration/views/reciver_new.html?v=' + viewVersion,
            controller: 'AdminReciverEdit',
            right: function(_$privileges) {

                return _$privileges.checkRightInRouting("admin");

            }
        })
        .state('admin_recivers_edit', {
            url: '/app/administration/recivers/:action/:id',
            templateUrl: path + '/administration/views/reciver_edit.html?v=' + viewVersion,
            controller: 'AdminReciverEdit',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })

    .state('admin_events', {
            url: '/app/administration/events',
            templateUrl: path + '/administration/views/eventviewers.html?v=' + viewVersion,
            controller: 'Events',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_systemsettings', {
            url: '/app/administration/settings',
            templateUrl: path + '/administration/views/systemsettings.html?v=' + viewVersion,
            controller: 'SystemSettings',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_backup', {
            url: '/app/administration/backup',
            templateUrl: path + '/administration/views/backup.html',
            controller: 'Backup',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_debug_epuap', {
            url: '/app/administration/debug',
            templateUrl: path + '/administration/views/debug.html',
            controller: 'Debug',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
    /*
     * GRUPY KOMUNIKATÓW
     */
    .state('admin_notificationscategories', {
            url: '/app/administration/notifications',
            templateUrl: path + '/administration/views/notifications_categories.html?v=' + viewVersion,
            controller: 'NotificationsCategories',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_notificationscategories_add', {
            url: '/app/administration/notifications/:action',
            templateUrl: path + '/administration/views/notifications_categories_edit.html?v=' + viewVersion,
            controller: 'NotificationsCategories',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        .state('admin_notificationscategories_edit', {
            url: '/app/administration/notifications/:action/:id',
            templateUrl: path + '/administration/views/notifications_categories_edit.html?v=' + viewVersion,
            controller: 'NotificationsCategories',
            resolve: {
                right: function(_$privileges) {

                    return _$privileges.checkRightInRouting("admin");

                }
            }
        })
        /**
         * SYSTEMY API
         */
        .state('admin_systemapi', {
            url: '/app/administration/systemapi',
            templateUrl: path + '/administration/views/system_api.html?v=' + viewVersion,
            controller: 'SystemApi',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('admin_systemapi_add', {
            url: '/app/administration/systemapi/new',
            templateUrl: path + '/administration/views/system_api_new.html?v=' + viewVersion,
            controller: 'SystemApiNew',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('admin_systemapi_edit', {
            url: '/app/administration/systemapi/:action/:id',
            templateUrl: path + '/administration/views/system_api_new.html?v=' + viewVersion,
            controller: 'SystemApiNew',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('admin_team', {
            url: '/app/administration/team',
            templateUrl: path + '/administration/views/teams.html?v=' + viewVersion,
            controller: 'Teams',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('admin_team_new', {
            url: '/app/administration/team/:action',
            templateUrl: path + '/administration/views/teams_edit.html?v=' + viewVersion,
            controller: 'Teams',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('admin_team_edit', {
            url: '/app/administration/team/:action/:id',
            templateUrl: path + '/administration/views/teams_edit.html?v=' + viewVersion,
            controller: 'Teams',
            resolve: {
                right: function(_$privileges) {
                    return _$privileges.checkRightInRouting("admin");
                }
            }
        })
        .state('homepage', {
            url: "/"
        })
        .state('login', {
            url: "/login"
        })
        .state('password_reset', {
            url: "/password/reset"
        })
        .state('password_reset_change', {
            url: "/password/reset/:hash"
        })
        .state("norights", {
            url: "/app/norights",
            templateUrl: path + '/403.html'
        })
        .state("otherwise", {
            url: "*path",
            templateUrl: path + '/404.html'
        });

});

app.run(function($rootScope, $state, _$toast, $q, $http, _$breadcrumbs, _$privileges, $document, $timeout, _$editmode,
    $templateCache) {
    //pobieranie uprawnień użtkownika

    //    _$privileges.init().success(function(){
    //            _$privileges.refresh();
    //    });

    function showLoader() {

        $(".full-loader").removeClass("hide").addClass("fadeIn");
    };

    function hideLoader() {

        $(".full-loader").removeClass("fadeIn").addClass("fadeOut");
        $timeout(function() {

            $(".full-loader").addClass("hide");

        }, 1000);
    };

    $rootScope.$on('$stateChangeStart',
        function(event, toState, toParams, fromState, fromParams, options) {

            showLoader();
            $templateCache.removeAll();
        });

    $rootScope.$on('$stateChangeError',
        function(event, toState, toParams, fromState, fromParams) {

            $state.go("norights");
            hideLoader();

        }
    );

    //set callbacks on stateRouter
    $rootScope.$on('$stateChangeSuccess',
        function(event, toState, toParams, fromState, fromParams) {

            hideLoader();

            _$editmode.turnOn();

            //generate breadcrumbs
            _$breadcrumbs.generateByStates(toState);

        }
    );

    $rootScope.tip = {
        showName: 0,
        showSurname: 0,
        direction: ''
    };

    $rootScope.notification = {
        show: function(type, msg) {
            if (type == 'success')
                _$toast.success(msg);
            else
                _$toast.error(msg);
        },
        showAfterRedirect: function(state, params, type, msg) {
            $state.go(state, params, {
                redirect: true
            }).then(function() {
                $rootScope.notification.show(type, msg);
            });
        }
    };
    $rootScope.checkboxList = {
        "ids": [],
        "idsCount": 0,
        "first": 0,
        "change": function(index) {
            if ($rootScope.checkboxList.ids[index] == -1) {
                $rootScope.checkboxList.idsCount--;
            } else {
                $rootScope.checkboxList.idsCount++;
            }
            if ($rootScope.checkboxList.idsCount > 0) {
                for (var i = 0; i < $rootScope.checkboxList.ids.length; i++) {
                    if ($rootScope.checkboxList.ids[i] != null && $rootScope.checkboxList.ids[i] != -1)
                        $rootScope.checkboxList.first = $rootScope.checkboxList.ids[i];
                }
            }
        },
        get: function() {
            var response = [];
            for (var i = 0; i < $rootScope.checkboxList.ids.length; i++) {
                if ($rootScope.checkboxList.ids[i] != null && $rootScope.checkboxList.ids[i] != -1)
                    response.push($rootScope.checkboxList.ids[i]);
            }
            return response;
        },
        "clear": function() {
            $rootScope.checkboxList.ids = [];
            $rootScope.checkboxList.idsCount = 0;
        },
        "checked": function(index) {
            if (typeof $rootScope.checkboxList.ids[index] == "undefined" || $rootScope.checkboxList.ids[index] == -1)
                return false;
            else
                return true;
        }
    };
    $rootScope.checkboxList.clear();
    $rootScope.formatDateFromStringToObject = function(date){
      var d = date.split(" ");
      var parts = d[0].split("-");
      return new Date(parts[0], parseInt(parts[1], 10) - 1, parts[2]);
    };
    $rootScope.formatDateFromObjectToString = function(date){
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      //return new Date(year+'-'+monthIndex+'-'+day);
      return year + '-' + (monthIndex + 1 < 10 ? 0 : '') + (monthIndex + 1) + '-' + (day < 10 ? '0' : '') + day;
    }
    $rootScope.formatDate = function(date) {
        if (date != null) {
            if (typeof date == "string") {
              return $rootScope.formatDateFromStringToObject(date);
            } else {
              return $rootScope.formatDateFromObjectToString(date);
            }
        }

        return date;
    };
    $rootScope.filters = [];
    /*
     * autocomplete
     */

    //    $rootScope.autocomplete = {
    //        searchText: {
    //            comunity: "",
    //            city: "",
    //            county: ""
    //        },
    //        querySearch: function (query, filter) {
    //            var results = query ? $rootScope.filters[filter].filter($rootScope.autocomplete.createFilterFor(query)) : $rootScope.filters[filter];
    //            var deferred = $q.defer();
    //            $timeout(function () {
    //                deferred.resolve(results);
    //            }, Math.random() * 1000, false);
    //            return deferred.promise;
    //
    //            var deferred = $q.defer();
    //            var action = filter;
    //            $http.post("/teryt/" + action, {"name": query}).then(function (results) {
    //
    //                deferred.resolve(results.data);
    //            });
    //            return deferred.promise;
    //        },
    //        createFilterFor: function (query) {
    //            return function filterFn(state) {
    //                return (state.name.indexOf(query) === 0);
    //            };
    //        }
    //    };
});
